/**
 * AdminPrivateRoute — auth check only, no AppShell wrapper.
 * Used for admin panels that have their own full-page headers
 * and need clean modal portals without AppShell layout interference.
 */
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AdminPrivateRoute = () => {
  const token = localStorage.getItem('token');
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default AdminPrivateRoute;
